/**
 * Floating Social Button Component
 * Shows after scroll threshold, opens popup with social links
 */

class FloatingSocialButton {
  constructor() {
    this.button = document.getElementById('floatingSocialButton');
    if (!this.button) return;

    this.trigger = this.button.querySelector('.floating-social-button__trigger');
    this.popup = this.button.querySelector('.floating-social-button__popup');
    this.scrollThreshold = parseInt(this.button.dataset.scrollThreshold) || 200;
    this.isOpen = false;
    this.hasScrolled = false;

    this.init();
  }

  init() {
    // Scroll detection
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollY = window.scrollY || window.pageYOffset;
          if (scrollY > this.scrollThreshold) {
            if (!this.hasScrolled) {
              this.button.classList.add('visible');
              this.hasScrolled = true;
            }
          } else {
            if (this.hasScrolled) {
              this.button.classList.remove('visible');
              this.close();
              this.hasScrolled = false;
            }
          }
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // Initial check
    handleScroll();

    // Toggle popup
    if (this.trigger) {
      this.trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggle();
      });
    }

    // Close on outside click
    document.addEventListener('click', (e) => {
      if (this.isOpen && !this.button.contains(e.target)) {
        this.close();
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });

    // Prevent popup from closing when clicking inside it
    if (this.popup) {
      this.popup.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    if (!this.trigger || !this.popup) return;
    this.isOpen = true;
    this.trigger.setAttribute('aria-expanded', 'true');
    this.popup.classList.add('open');
    
    // Focus first link for accessibility
    const firstLink = this.popup.querySelector('.floating-social-button__link');
    if (firstLink) {
      setTimeout(() => firstLink.focus(), 100);
    }
  }

  close() {
    if (!this.trigger || !this.popup) return;
    this.isOpen = false;
    this.trigger.setAttribute('aria-expanded', 'false');
    this.popup.classList.remove('open');
    this.trigger.focus();
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new FloatingSocialButton();
  });
} else {
  new FloatingSocialButton();
}
